export default __webpack_public_path__ + "static/media/african-drum.c7d7e26f.png";